import { goalActivity as goalActivityConfig } from 'shared/api/query/configs.json';
import { propertyType } from 'shared/constants.json';

export const directProperties = ($t) => ([
  {
    label: $t('general.createdAt'),
    edgeName: goalActivityConfig.edges.customCreatedAt,
    type: propertyType.date,
    isTitle: false,
    hideInProps: true,
    noFilter: false,
    noIsEmptyFilter: true,
    showByDefault: true,
  },
]);
